(() => {
  if (!document.body.classList.contains('fc-festival')) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const home = !!document.querySelector('.fc-royal-hero');
  if (!home && !document.querySelector('.fc-royal-gallery')) return;
  if (document.querySelector('.fc-royal-fireworks')) return;
  const canvas = document.createElement('canvas');
  canvas.className = 'fc-royal-fireworks';
  canvas.setAttribute('aria-hidden', 'true');
  canvas.dataset.scope = home ? 'homepage' : 'product';
  canvas.dataset.phase = 'idle';
  const ctx = canvas.getContext('2d', { alpha: true });
  if (!ctx) return;
  canvas.hidden = true;
  document.body.append(canvas);
  let w, h, ratio, frame=0, start=0, previous=0, duration=5, active=false, destroyed=false;
  let launches=[], particles=[], endTimer=0, fadeTimer=0, scrollTimer=0;
  let lastY=window.scrollY, lastPlayed=-Infinity, sequence=0;
  const palette=['#cd8a20','#e8ad38','#c83b25','#c42254','#af721e'];
  const blocked=()=>reduced.matches||document.body.classList.contains('paused')||window.FC_MOTION===false||document.hidden;
  function size(){
    w=innerWidth;h=innerHeight;ratio=Math.min(devicePixelRatio||1,1.5);
    canvas.width=Math.round(w*ratio);canvas.height=Math.round(h*ratio);
    ctx.setTransform(ratio,0,0,ratio,0,0);
  }
  function burst(x,y,color){
    const small=w<750,count=small?36:58;
    for(let i=0;i<count;i++){
      const angle=i/count*Math.PI*2,speed=(small?42:68)+Math.random()*(small?42:68);
      particles.push({x,y,vx:Math.cos(angle)*speed,vy:Math.sin(angle)*speed,life:1.3+Math.random()*.5,color:palette[(color+i%2)%palette.length]});
    }
  }
  function end(){
    if(!active)return;
    active=false;cancelAnimationFrame(frame);clearTimeout(endTimer);
    canvas.dataset.phase='idle';canvas.classList.add('is-finished');
    particles=[];
    fadeTimer=setTimeout(()=>{canvas.hidden=true;ctx.clearRect(0,0,w,h);},520);
  }
  function play(welcome){
    if(active||destroyed||blocked())return;
    clearTimeout(fadeTimer);size();canvas.hidden=false;canvas.classList.remove('is-finished');
    active=true;start=0;previous=0;particles=[];duration=welcome?5:3.4;
    lastPlayed=performance.now();lastY=window.scrollY;
    canvas.dataset.sequence=String(++sequence);canvas.dataset.trigger=welcome?'welcome':'scroll';
    launches=welcome?[
      {at:0,x:.10,y:.65,c:0},{at:.18,x:.88,y:.30,c:3},
      {at:.65,x:.32,y:.18,c:1},{at:.9,x:.70,y:.70,c:2},
      {at:1.45,x:.12,y:.38,c:3},{at:1.7,x:.87,y:.82,c:0},
      {at:2,x:.52,y:.43,c:1}
    ]:[{at:0,x:.10,y:.35,c:sequence%5},{at:.3,x:.88,y:.68,c:(sequence+2)%5},{at:.65,x:.28,y:.18,c:1}];
    frame=requestAnimationFrame(draw);endTimer=setTimeout(end,duration*1000+450);
  }
  function draw(now){
    if(!active)return;
    if(blocked()){end();return;}
    if(!start)start=now;
    const t=(now-start)/1000,dt=Math.min((t-previous)||.016,.033);previous=t;
    ctx.clearRect(0,0,w,h);
    canvas.dataset.phase=t<.7?'rockets':t<duration-1?'fireworks':'fading';
    for(const rocket of launches){
      const p=(t-rocket.at)/.65;
      if(p<0||rocket.done)continue;
      const x=w*rocket.x,y=Math.max(95,h*rocket.y);
      if(p>=1){rocket.done=true;burst(x,y,rocket.c);continue;}
      const sy=Math.min(h+25,y+Math.min(300,h*.45));
      const ry=sy+(y-sy)*(1-Math.pow(1-p,2)),rx=x+(rocket.x<.5?-20:20)*(1-p);
      const gradient=ctx.createLinearGradient(rx,ry,rx,ry+70);
      gradient.addColorStop(0,'#d48b22');gradient.addColorStop(1,'#e4a94400');
      ctx.strokeStyle=gradient;ctx.lineWidth=2;ctx.beginPath();ctx.moveTo(rx,ry);ctx.lineTo(rx,ry+70);ctx.stroke();
      ctx.fillStyle='#d99b2d';ctx.beginPath();ctx.arc(rx,ry,3,0,Math.PI*2);ctx.fill();
    }
    for(let i=particles.length-1;i>=0;i--){
      const p=particles[i];p.life-=dt;
      if(p.life<=0){particles.splice(i,1);continue;}
      p.x+=p.vx*dt;p.y+=p.vy*dt;p.vy+=26*dt;p.vx*=.99;
      ctx.globalAlpha=Math.max(0,Math.min(1,p.life/.55,duration-t));
      ctx.strokeStyle=p.color;ctx.lineWidth=w<750?1.7:2;
      ctx.beginPath();ctx.moveTo(p.x,p.y);ctx.lineTo(p.x-p.vx*.055,p.y-p.vy*.055);ctx.stroke();
      ctx.fillStyle=p.color;ctx.beginPath();ctx.arc(p.x,p.y,1.4,0,Math.PI*2);ctx.fill();
    }
    ctx.globalAlpha=1;
    if(t>=duration){end();return;}
    frame=requestAnimationFrame(draw);
  }
  function scroll(){
    if(!home||destroyed)return;
    clearTimeout(scrollTimer);
    scrollTimer=setTimeout(()=>{
      if(Math.abs(window.scrollY-lastY)>=innerHeight*.55&&performance.now()-lastPlayed>4200)play(false);
    },100);
  }
  function pause(event){if(event.target.closest('[data-action="motion"]'))end();}
  function visibility(){if(document.hidden)end();}
  function preference(){if(reduced.matches)end();}
  function destroy(){
    end();destroyed=true;clearTimeout(fadeTimer);clearTimeout(scrollTimer);clearTimeout(endTimer);
    window.removeEventListener('scroll',scroll);window.removeEventListener('resize',size);
    document.removeEventListener('click',pause);document.removeEventListener('visibilitychange',visibility);
    reduced.removeEventListener('change',preference);canvas.remove();
  }
  window.addEventListener('resize',size,{passive:true});
  if(home)window.addEventListener('scroll',scroll,{passive:true});
  document.addEventListener('click',pause);document.addEventListener('visibilitychange',visibility);
  reduced.addEventListener('change',preference);window.addEventListener('pagehide',destroy,{once:true});
  play(true);
})();
